(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desktop-hover-header"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('desktop-hover-menu')) {
    customElements.define('desktop-hover-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.details = this.querySelector('.dh-disclosure');
        this.summary = this.querySelector('.dh-trigger');
        this.panel = this.querySelector('.dh-panel');
        this.photo = this.querySelector('[data-preview-photo]');
        this.label = this.querySelector('[data-preview-label]');
        this.art = this.querySelector('.dh-preview-art');
        this.initial = this.querySelector('[data-preview-initial]');
        this.desktop = matchMedia('(min-width: 990px)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.sequence = 0;
        this.cache = new Map();
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        this.summary.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !this.hover.matches || !this.desktop.matches) return;
          clearTimeout(this.closeTimer);
          this.openTimer = setTimeout(() => this.open(), 100);
        }, options);
        const scheduleClose = () => {
          clearTimeout(this.openTimer);
          clearTimeout(this.closeTimer);
          this.closeTimer = setTimeout(() => {
            if (!this.details.contains(document.activeElement)) this.close();
          }, 200);
        };
        this.details.addEventListener('pointerleave', scheduleClose, options);
        this.querySelector('.dh-backdrop').addEventListener('pointerenter', scheduleClose, options);
        this.details.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
        this.panel.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
        this.details.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', String(this.details.open));
          if (this.details.open) {
            for (const menu of this.closest('.dh-header').querySelectorAll('desktop-hover-menu')) {
              if (menu !== this) menu.close?.();
            }
            this.position();
          }
          else clearTimeout(this.openTimer);
        }, options);
        this.summary.addEventListener('click', () => {
          clearTimeout(this.openTimer);
          if (!this.details.open) this.closePeers();
        }, options);
        this.summary.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          this.open();
          this.panel.querySelector('.dh-collection-link, [data-preview-item]')?.focus();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !this.details.open) return;
          event.preventDefault();
          this.close(true);
        }, options);
        this.details.addEventListener('focusout', event => {
          if (!this.details.contains(event.relatedTarget)) this.close();
        }, options);
        for (const eventName of ['pointerover', 'focusin', 'click']) {
          this.panel.addEventListener(eventName, event => {
            const item = event.target.closest('[data-preview-item]');
            if (item) this.preview(item);
          }, options);
        }
        this.querySelector('[data-close]').addEventListener('click', () => this.close(true), options);
        this.querySelector('.dh-backdrop').addEventListener('pointerdown', () => this.close(), options);
        document.addEventListener('pointerdown', event => {
          if (!this.details.contains(event.target)) this.close();
        }, options);
        window.addEventListener('resize', () => {
          if (!this.desktop.matches) this.close();
          else if (this.details.open) this.position();
        }, options);
        window.addEventListener('scroll', () => {
          if (!this.details.open || this.positionFrame) return;
          this.positionFrame = requestAnimationFrame(() => {
            this.positionFrame = 0;
            if (this.closest('.dh-header').getBoundingClientRect().bottom <= 0) this.close();
            else this.position();
          });
        }, { ...options, passive: true });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          this.open();
          const item = event.target.querySelector('[data-preview-item]');
          if (item) this.preview(item);
        }, options);
        this.observer = new ResizeObserver(() => {
          if (this.details.open) this.position();
        });
        this.observer.observe(this.closest('.dh-header').querySelector('.dh-bar'));
      }
      position() {
        this.closest('.dh-header').style.setProperty('--dh-header-bottom', `${Math.max(0, this.closest('.dh-header').getBoundingClientRect().bottom)}px`);
      }
      closePeers() {
        for (const menu of this.closest('.dh-header').querySelectorAll('desktop-hover-menu')) {
          if (menu !== this) menu.close?.();
        }
      }
      open() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        if (!this.desktop.matches) return;
        this.closePeers();
        this.position();
        this.details.open = true;
        this.summary.setAttribute('aria-expanded', 'true');
      }
      close(restoreFocus = false) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.details.open = false;
        this.summary.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.summary.focus({ preventScroll: true });
      }
      async preview(item) {
        if (this.activeItem === item) return;
        this.activeItem?.removeAttribute('data-active');
        this.activeItem = item;
        item.setAttribute('data-active', '');
        const sequence = ++this.sequence;
        const profileTemplate = item.parentElement.querySelector('[data-profile-template]');
        const profileRegion = this.querySelector('[data-profile-region]');
        if (profileTemplate && profileRegion) {
          profileRegion.replaceChildren(document.importNode(profileTemplate.content, true));
          for (const choice of this.querySelectorAll('[data-profile-choice]')) choice.setAttribute('aria-pressed', String(choice === item));
        }
        const title = item.dataset.previewLabel || '';
        const template = item.parentElement.querySelector('[data-preview-template]');
        let nextImage = null;
        if (template) {
          if (!this.cache.has(template)) {
            const candidate = document.importNode(template.content.querySelector('img'), true);
            this.cache.set(template, candidate.decode().then(() => candidate).catch(() => null));
          }
          nextImage = await this.cache.get(template);
        }
        if (sequence !== this.sequence || !this.isConnected) return;
        this.label.textContent = title;
        this.initial.textContent = title.slice(0, 1);
        this.art.style.setProperty('--dh-preview-tone', item.dataset.previewTone || '#d2dacb');
        this.photo.replaceChildren(...(nextImage ? [nextImage] : []));
        if (nextImage && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          nextImage.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' });
        }
      }
      disconnectedCallback() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.positionFrame);
        this.sequence++;
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tayco-article"]) return;
  try {
    
if(!customElements.get('tayco-article'))customElements.define('tayco-article',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.events=new AbortController();const signal=this.events.signal;const content=this.querySelector('[data-article-content]');const toc=this.querySelector('[data-toc]');const headings=[...content.querySelectorAll('h2')];if(toc&&headings.length>1){const list=this.querySelector('[data-toc-list]');list.replaceChildren();headings.forEach((heading,index)=>{if(!heading.id){let id='tayco-section-'+(index+1);while(document.getElementById(id))id+='-section';heading.id=id}const li=document.createElement('li');const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;li.append(link);list.append(li)});toc.hidden=false;toc.open=!matchMedia('(max-width:989px)').matches}const button=this.querySelector('[data-copy]');button.hidden=false;button.addEventListener('click',async()=>{const status=this.querySelector('[data-copy-status]');try{await navigator.clipboard.writeText(this.dataset.shareUrl);status.textContent=this.dataset.copySuccess}catch{status.textContent=this.dataset.copyError}},{signal});const bar=this.querySelector('[data-reading-progress]');let frame=0;const update=()=>{frame=0;const r=content.getBoundingClientRect();const value=Math.max(0,Math.min(1,(innerHeight-r.top)/(r.height+innerHeight)));bar.style.transform='scaleX('+value+')'};const schedule=()=>{if(!frame)frame=requestAnimationFrame(update)};window.addEventListener('scroll',schedule,{passive:true,signal});window.addEventListener('resize',schedule,{passive:true,signal});update()}
disconnectedCallback(){this.events?.abort();this.ready=false}
});

  } catch(e) { console.error(e); }
})();
})();
